import _default from './Dropdown';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Dropdown/index.js
// module id = 172
// module chunks = 0